import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { showFreight } from '../../store/ducks/freight/actions';

export default function UseGetFreight() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(
    freightId: string,
    status?: string,
    period?: string,
    callBack?: (data: any) => void,
  ) {
    try {
      setLoading(true);
      const response = await api.get(`v1/backoffice/freights/${freightId}`, {
        params: {
          curretPage: 1,
          status: status,
        },
      });

      if (response.status === 200) {
        dispatch(
          showFreight({
            freight: response.data,
          }),
        );

        return response.data;
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.operationFailed);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
